// Modules
import { Injectable } from '@angular/core';
import { SbiToastService } from '@shared-module/services/sbi-toast/sbi-toast.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';

// Rxjs
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

// Store - Actions
import * as DashboardActions from '@store/actions/dashboard.actions';

// Services
import { DashboardService } from '@services/dashboard/dashboard-settings.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardEffects {
  // Constructor
  constructor(
    private readonly _sbiToast: SbiToastService,
    private _actions$: Actions,
    private _dashboardService: DashboardService
  ) {}

  getDashboardAutoStatistics$ = createEffect(() =>
    this._actions$.pipe(
      ofType(DashboardActions.getAutoStatisticsRequested),
      switchMap(action =>
        this._dashboardService.getDashboardAutoStatistics(action.payload).pipe(
          map(response =>
            DashboardActions.getAutoStatisticsResponse({ payload: response })
          ),
          catchError(() => {
            this._sbiToast.error('Error obteniendo información del dashboard');
            return of(
              DashboardActions.getAutoStatisticsResponse({ payload: null })
            );
          })
        )
      )
    )
  );
}
